module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/hhPurpleLogo-00670bb19821a83de3f4e30c7b1b4823.png";